<template>
  <v-container>
    <component v-if="plugin && isServiceOnline && pluginInterface" v-bind:is="pluginInterface.component" />
    <div v-if="isInitialized === true && isServiceOnline === false">
      <v-alert outline :value="true" type="error">Uh oh! This plugin is not available, please contact technical support
        if the problem persists.</v-alert>
    </div>
    <div v-if="isInitialized === false">
      <v-alert outline :value="true" type="error">Uh oh! This plugin encountered an error, please contact technical
        support if the problem persists.</v-alert>
    </div>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const services = createNamespacedHelpers('services')
  const plugin = createNamespacedHelpers('plugin')

  export default {
    components: {},
    props: {
      serviceLink: {
        type: String,
        required: true,
      },
      interfaceType: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      // Title and description come from the Service Registry, and are saved during registration
      pingTimerId: null,
      isServiceOnline: null,
      isInitialized: null,
      pluginPingIntervalMilliseconds: 15000, // 15 secs
    }),
    computed: {
      ...plugin.mapGetters(['activePluginByServiceLink']),
      plugin() {
        return this.activePluginByServiceLink(this.serviceLink)
      },
      pluginInterface() {
        if (!this.plugin) {
          return
        }
        return this.plugin.interfaces[this.interfaceType]
      },
      pageTitle() {
        return this.pluginInterface && this.pluginInterface.pageTitle
      },
      description() {
        return this.pluginInterface && this.pluginInterface.description
      },
      noPadding() {
        return this.pluginInterface && this.pluginInterface.noPadding
      },
    },
    watch: {
      plugin() {
        if (this.plugin) {
          this.isInitialized = true
          // this.startContinuousPing({ serviceId: this.plugin.service.id })
        } else {
          this.isInitialized = false
        }
      },
    },
    mounted() {
      if (this.plugin) {
        this.isInitialized = true
        this.startContinuousPing({ serviceId: this.plugin.service.id })
      } else {
        this.isInitialized = false
      }
    },
    methods: {
      ...services.mapActions(['pingServices']),
      ...plugin.mapActions(['initialize']),
      async startContinuousPing({ serviceId } = {}) {
        if (this.pingTimerId) return
        if (!serviceId) {
          throw 'Service id required'
        }
        let pingCb = async () => {
          this.isServiceOnline = await this.pingService({ serviceId })
        }
        await pingCb()
        this.pingTimerId = setInterval(
          pingCb,
          this.pluginPingIntervalMilliseconds
        )
      },
      async pingService({ serviceId } = {}) {
        let response
        if (!serviceId) {
          throw 'Service id required'
        }
        try {
          response = await this.pingServices({
            serviceId: serviceId,
          })
        } catch (ex) {
          response = false
        }
        return response && response.Active
      },
    },
    beforeDestroy() {
      if (this.pingTimerId) {
        clearTimeout(this.pingTimerId)
        this.pingTimerId = null
      }
    },
  }
</script>